/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description: 接口文档
 * @LastEditTime: 2021-05-24 17:27:58
 */

import { request } from "./api-require";
import { objAny } from "../common/common-interface";
const API_URL = "/basic-system/v1";
//登录
export const sysLogin = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/auth/login", data, config);
};
//退出登录
export const sysLoginOut = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/auth/logout", data, config);
};
//获取字典大类信息列表
export const getDictTypeList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/dict/type/list", data, config);
};
//获取字典大类信息列表---分页
export const getDictTypeListPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/dict/type/page", data, config);
};
//新增字典大类
export const addDictType = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/dict/type/add", data, config);
};
//修改字典大类
export const upDictType = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/dict/type/upd", data, config);
};
//删除字典大类
export const delDictType = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/dict/item/delete", data, config);
};
//根据字典小类pkid的操作排序
export const sortDictType = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/dict/item/sort", data, config);
};

//获取字典信息指定大类下小类列表
export const getDictItemAll = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/dict/item/list", data, config);
};
//分页获取字典信息指定大类下小类列表
export const getDictItemList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/dict/item/page", data, config);
};
//批量获取多个字典信息大类下小类列表集合
export const getDictItemAllList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/dict/item/list_batch", data, config);
};
//修改字典小类
export const upDictItem = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/dict/item/upd", data, config);
};
//新增字典小类
export const addDictItem = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/dict/item/add", data, config);
};
//删除字典小类
export const delDictItem = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/dict/item/del", data, config);
};
//在线用户
export const getOnlineuser = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/online_user/page", data, config);
};
//强制下线
export const outUser = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/online_user/offline", data, config);
};
//上传图片
export const uploadImage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/file/upload_image", data, config);
};
//上传文件
export const uploadFile = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/file/upload", data, config);
};
//下载文件
export const downloadFile = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/file/download", data, config);
};
// 获取运营商
export const getSearchInitData = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/alarm/searchInitData", data, config);
};
//查看所有运营商列表
export const getAllOperList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/opr/list", data, config);
};
// 通过运营商获取充电桩
export const getStationByOpr = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/alarm/getStationByOpr", data, config);
};
//获取省市区
export const getFindAreaList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/region/findAreaList", data, config);
};

//发送短信验证码
export const getCodeSms = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/vercode/sms_test", data, config);
};

//重置密码
export const resetSelfPwd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/user/reset_self_pwd", data, config);
};
//用户
//查询所有运营商自定义角色列表
export const getAllRole = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/role/all", data, config);
};

//分页查询运营商自定义角色列表
export const getRoleList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/role/page", data, config);
};
//保存角色
export const saveRole = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/role/save", data, config);
};
//删除角色
export const delRole = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/role/delete", data, config);
};
//保存接口权限
export const saveInterfacePermission = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/role/save_interface_permission", data, config);
};
//菜单权限列表
export const getPermission = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/role/permission", data, config);
};
//查询菜单接口权限列表
export const getInterfacePermission = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/role/query_interface_permission", data, config);
};
//获取角色功能菜单权限
export const getrRolePermission = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/user/role_permission", data, config);
};
//根据不同用户角色类型 及 所属系统 查询角色列表
export const getRoleSelect = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/role/select", data, config);
};
//根据userid 获取角色
export const getUserRole = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/role/select", data, config);
};
//获取角色详情
export const getRoleDetails = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/role/selectOne", data, config);
};
//保存角色权限
export const setPermission = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/role/set_permission", data, config);
};

//查询设备型号列表
export const getModelList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/device/model/list", data, config);
};

//分页获取充电桩信息
export const getDeviceOprPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/opr/page", data, config);
};

//添加充电桩
export const getDeviceOprAdd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/opr/add", data, config);
};

//获取充电桩详情
export const getDeviceOprDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/device/opr/detail", data, config);
};

//修改充电桩
export const getDeviceOprUpd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/opr/upd", data, config);
};

//修改充电桩
export const updateDeviceOprStatus = (data = {}, config: objAny = {}) => {
  // config.method = "get";
  config.method = "get";

  return request(API_URL + "/sys/device/opr/upd_device_status", data, config);
};
// 获取警告查询
export const getAlarmQuery = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/alarm/query", data, config);
};

// 获取警告详情
export const getAlarmOrderDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/queryOrderDetail", data, config);
};

//设备厂商--分页获取
export const getManufacturerPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/manufacturer/page", data, config);
};

//设备厂商--新增
export const addManufacturer = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/manufacturer/add", data, config);
};

//设备厂商--修改
export const updManufacturer = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/manufacturer/upd", data, config);
};

//设备厂商--删除
export const delManufacturer = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/device/manufacturer/del", data, config);
};
//获取用户列表
export const getUserList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/user/page", data, config);
};
//修改用户
export const updDataUser = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/user/upd", data, config);
};
//新增用户
export const addUser = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/user/add", data, config);
};
//删除用户
export const deleteUser = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/user/del", data, config);
};

//删除用户
export const getOprRoleAll = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/role/all", data, config);
};

//分页查询运营商自定义角色列表
export const getOprRolePage = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/role/page", data, config);
};

//新增/修改角色和权限
export const getOprRoleSave = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/role/save", data, config);
};

//分页查询运营商自定义角色列表
export const getOprRoleDel = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/role/del", data, config);
};

//分页查询运营商自定义角色列表
export const getOprRolePermission = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/role/permission", data, config);
};

//发送短信验证码
export const vercodeSms = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/vercode/sms", data, config);
};
//发送短信验证码测试
export const vercodeSmsTest = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/vercode/sms_test", data, config);
};
//校验短信验证码
export const vercodeSmsValidate = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/vercode/sms/validate", data, config);
};
//修改密码--重置密码
export const forgetResetPwd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/auth/forget_reset_pwd", data, config);
};

//系统更新日志
export const systemUpdateLog = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/system_update/page", data, config);
};
// /basic-system/system_update/base-upgrade-log/page

// /alarm/count
export const alarmCount = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/summary", data, config);
};

//告警概要总值
export const alarmSummary = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/summary", data, config);
};

//告警概要trend
export const alarmTrend = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/trend", data, config);
};

//告警概要充电站top5
export const alarmStationTop5 = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/station/top5", data, config);
};

//告警概要设备top5
export const alarmChargeTop5 = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/charge/top5", data, config);
};

// 分页获取设备型号列表
export const getModelListPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/model/page", data, config);
};

// 新增设备型号
export const addModelNew = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/model/add", data, config);
};

// 删除设备型号
export const delOneModel = (data = {}, config: objAny = {}) => {
  config.method = "del";
  return request(API_URL + "/sys/device/model/del_batch", data, config);
};

// 修改设备型号
export const updModelNew = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/model/upd", data, config);
};

// 分页获取设备清单
export const getDevicePageList = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/page", data, config);
};
// 获取设备统计
export const getDeviceCout = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/get_cout", data, config);
};
//批量删除设备
export const delBatch = (data = {}, config: objAny = {}) => {
  config.method = "del";
  return request(API_URL + "/sys/device/del_batch", data, config);
};

//批量设备绑定运营商
export const bindOperBatch = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/bind_oper_batch", data, config);
};

//批量设备解绑运营商
export const unbindOperBatch = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/unbind_oper_batch", data, config);
};
//根据运营商获取充电站
export const getStation = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/getStationByOpr", data, config);
};
//批量设备修改型号
export const upDevModel = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/upd_model_batch", data, config);
};

// 设备型号批量添加设备
export const pilesAddBatch = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/manage/add_batch", data, config);
};

// 获取设备型号标配或选配参数列表
export const getModelOptionsList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/device/model/options/list", data, config);
};

// 获取设备型号详情
export const deviceModelDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/device/model/detail", data, config);
};

//设备厂商下拉接口
export const getManufacturerList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/device/manufacturer/get", data, config);
};
//修改充电枪信息
export const chargeGunUpd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/opr/upd_charge_gun", data, config);
};

//下发费率--下发电价
export const sendSyncfeeRatecmd = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    API_URL + "/sys/device/opr/send_syncfee_ratecmd",
    data,
    config
  );
};
//解锁,下发二维码
export const sendPileOperation = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/device/opr/send_pile_operation", data, config);
};
// 查看用户已关联的站点
export const oprUserStaBound = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/user/sta/bound", data, config);
};

// 查看用户未关联的站点
export const oprUserStaUnbound = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/opr/user/sta/unbound", data, config);
};
//关联站点
export const oprUserOperationSta = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/opr/user/operation/sta", data, config);
};

//解绑站点
export const unbindSta = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/device/opr/dev_unbind_sta", data, config);
};

// 分页查询Sim卡
export const getSIMCardPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/sim/page", data, config);
};

// 获取SIM详情
export const SIMCardDetail = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/sim/detail", data, config);
};

// 新增SIM卡
export const SIMCardAdd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/sim/add", data, config);
};

// 修改SIM卡
export const SIMCardUpd = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/sim/update", data, config);
};

// 统计SIM卡数据
export const SIMTotal = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/sim/total/sim_gird", data, config);
};

// 导入SIM
export const SIMImport = (data = {}, config: objAny = {}) => {
  // config.method = "get";
  return request(API_URL + "/sys/sim/import/sim_gird", data, config);
};

// 查询模板文件信息
export const SIMTemplateSelect = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/template/select", data, config);
};
//  修改个人密码
export const userResetpwdPersonal = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/user/resetpwd/personal", data, config);
};

// 今日告警
export const getAlarmToday = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/today", data, config);
};
// 告警概览-汇总数据
export const getAlarmSummary = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/summary", data, config);
};
// 充电站告警排名top
export const getAlarmStaTop5 = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/sta/top", data, config);
};
// 告警查询  /basic-system/v1/alarm/query
export const getAlarmQuerys = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/alarm/query", data, config);
};

// 充电桩告警排名top
export const getAlarmPileTop5 = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/alarm/pile/top", data, config);
};

// 获取运营商的登录地址
export const getLoginUrl = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/opr/get_login_url", data, config);
};
// 获取idemToken的接口
export const getAuthIdempotence = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/auth/idempotence", data, config);
};
// 获取设备采集扩展属性列表
export const getExpandPropertyList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    API_URL + "/sys/device/manage/expand/property/list",
    data,
    config
  );
};

// 获取区号列表
export const getCountryCodeList = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/sys/user/getCountryCodeList", data, config);
};

// 获取区号列表
export const getAccount = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/sys/user/get_account_info", data, config);
};
